import { ORDER_TYPES } from '@/pages/cars/returnCar/config'

export const mixin = {
  data() {
    return {
      returnCarInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '车牌号',
              prop: 'plateNo',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '所属部门',
              prop: 'deptName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单ID',
              prop: 'id',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '退车类型',
              prop: 'returnType',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '退车原因',
              prop: 'returnReason',
            },
          },
        ],
        model: {
          plateNo: '', // 车牌号
          customerName: '', // 客户名称
          deptName: '', // 所属部门名称
          id: '', // 订单ID
          returnType: '', // 退车类型
          returnReason: '', // 退车原因
        },
      },
      carInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '车牌号',
              prop: 'plateNo',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆ID',
              prop: 'carId',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '品牌',
              prop: 'brandName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车系',
              prop: 'seriesName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车型',
              prop: 'modelName',
              width: 160,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车架号（VIN码）',
              prop: 'vin',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆状态',
              prop: 'carState',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '库存状态',
              prop: 'inventoryState',
            },
          },
        ],
        model: {
          plateNo: '', // 车牌号
          carId: '', // 车辆ID
          modelName: '', // 车型
          carState: '', // 车辆状态
          inventoryState: '', // 库存状态
          vin: '',
        },
      },
      orderInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '订单ID',
              prop: 'id',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '企业主订单ID',
              prop: 'entRentOrderId',
            },
            isShow: this.orderType === ORDER_TYPES.enterprise.value,
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单类型',
              prop: 'type',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单状态',
              prop: 'state',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '收款起止日',
              prop: 'receivablePeriod',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '赠送天数',
              prop: 'presentDays',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '免租周期',
              prop: 'presentDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '租金总金额',
              prop: 'totalAmount',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '押金金额',
              prop: 'totalDeposit',
            },
          },
        ],
        model: {
          id: '', // 订单ID
          entRentOrderId: '', // 企业主订单ID
          type: '', // 订单类型
          state: '', // 订单状态
          receivablePeriod: '', // 收款起止日
          presentDays: '', // 赠送天数
          presentDate: '', // 免租周期 presentStartDate presentEntDate
          totalAmount: '', // 每期租金
          totalDeposit: '', // 押金
        },
      },
      customerInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '客户ID',
              prop: 'customerId',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户类型',
              prop: 'customerType',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
          },
        ],
        model: {
          customerId: '', // 客户ID
          customerType: '', // 客户类型
          customerName: '', // 客户名称
        },
      },
    }
  },
}
